import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Grid2X2 } from "lucide-react";
import { CATEGORIES } from "../../data/content";
import { reveal } from "../../lib/motion";

export const Categories = () => {
  const [active, setActive] = useState(CATEGORIES[0].id);
  const category = CATEGORIES.find((c) => c.id === active);

  return (
    <section
      data-testid="categories-section"
      className="bg-cream py-16 md:py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <motion.p
          {...reveal()}
          className="text-center text-xs font-semibold uppercase tracking-[0.3em] text-gold"
        >
          A Rede de Profissionais
        </motion.p>
        <motion.h2
          {...reveal(0.1)}
          className="mx-auto mt-4 max-w-3xl text-center font-serif text-3xl leading-tight text-ink sm:text-4xl lg:text-5xl"
        >
          "Seu talento também pode ser{" "}
          <em className="italic text-teal">uma forma de servir."</em>
        </motion.h2>

        <motion.div
          {...reveal(0.2)}
          className="-mx-5 mt-12 flex gap-3 overflow-x-auto px-5 pb-2 sm:mx-0 sm:flex-wrap sm:justify-center sm:overflow-visible sm:px-0"
        >
          {CATEGORIES.map((c) => (
            <button
              key={c.id}
              data-testid={`category-tab-${c.id}`}
              onClick={() => setActive(c.id)}
              className={`whitespace-nowrap rounded-full border px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] transition-all duration-300 ${
                active === c.id
                  ? "border-teal bg-teal text-white shadow-[0_8px_24px_rgba(27,139,139,0.35)]"
                  : "border-gold-border bg-white text-mutedink hover:border-teal hover:text-teal"
              }`}
            >
              {c.label}
            </button>
          ))}
        </motion.div>

        <div className="mt-12">
          <AnimatePresence mode="wait">
            <motion.div
              key={active}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -16 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4 lg:gap-8"
            >
              {category.items.map((item, i) => (
                <div
                  key={item}
                  data-testid={`category-card-${category.id}-${i}`}
                  className="group rounded-3xl border border-gold-border bg-white p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-gold hover:shadow-[0_20px_60px_rgba(197,160,89,0.12)]"
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gold-light transition-colors duration-300 group-hover:bg-teal-light">
                    <Grid2X2 className="h-5 w-5 text-gold transition-colors duration-300 group-hover:text-teal" />
                  </div>
                  <h3 className="mt-6 font-serif text-2xl text-ink">{item}</h3>
                  <p className="mt-2 text-sm text-mutedink">
                    Profissionais cristãs verificadas em {category.label}
                  </p>
                </div>
              ))}
            </motion.div>
          </AnimatePresence>
        </div>

        <motion.div {...reveal()} className="mt-12 text-center">
          <button
            data-testid="all-categories-btn"
            onClick={() =>
              document.getElementById("seu-lugar")?.scrollIntoView({ behavior: "smooth" })
            }
            className="text-xs font-semibold uppercase tracking-[0.25em] text-teal transition-colors duration-300 hover:text-teal-hover"
          >
            Ver todas as categorias →
          </button>
        </motion.div>
      </div>
    </section>
  );
};
